<template>
    <div>
        <p class="stack-m">Schedule {{relatedEventName}} Reminder using the following schedule:</p>
        <table class="table table-definition stack-m">
            <colgroup>
                <col style="width:100px;">
                <col>
            </colgroup>
            <tbody>
            <tr v-for="(summary, index) in lines" :key="index">
                <td>Attempt #{{index+1}}</td>
                <td>{{summary}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import ReminderActionSummary from '@/modules/rules-engine/actions/reminder-action-summary';

    export default {
        name: 'schedule-reminder-summary',
        extends: ReminderActionSummary,
        computed: {
            lines() {
                return this.action.getSummary(this.relatedEventName);
            },
        },
    };
</script>
